// extracted by mini-css-extract-plugin
module.exports = {"content":"SubjectStatusView_content__3FktP","itemForContent":"SubjectStatusView_itemForContent__tM2cY"};